/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import React from 'react';

interface Props {
  percentage: number;
  isActive?: boolean;
  bottomRounded?: boolean;
  thin?: boolean;
  minWidth?: number;
  bemModifier: string | number;
}

export default function ProgressBar({
  percentage,
  isActive,
  bottomRounded,
  thin,
  minWidth,
  bemModifier,
}: Props): JSX.Element {
  return (
    <div
      id={`ProgressBar_container_${bemModifier}`}
      className={`progress-bar-container ${thin ? 'thin' : ''} ${bottomRounded ? 'border-bottom-radius' : ''}`}
    >
      <div
        id={`ProgressBar_indicator_${bemModifier}`}
        className={`progress-bar-indicator ${isActive ? 'active' : ''} ${bottomRounded ? 'border-bottom-radius' : ''}`}
        style={{
          width: `${percentage}%`,
          borderBottomRightRadius: percentage === 100 && bottomRounded ? '2px' : '',
          minWidth: minWidth ? `${minWidth}px` : '',
        }}
      />
    </div>
  );
}
